const p4ValidationEndpoints = {
  // Réponse paginée `{ items, totalElements }` — fetch-all (size large) pour paginer côté client.
  pending: "/scoring/p4-validations/pending?page=0&size=500",
  // Historique par statut (APPROVED / REJECTED / PENDING) — même enveloppe paginée.
  byStatus: (status: string) =>
    `/scoring/p4-validations/by-status/${status}?page=0&size=500`,
  pendingCount: "/scoring/p4-validations/pending/count",
  approve: (validationId: string) =>
    `/scoring/p4-validations/${validationId}/approve`,
  reject: (validationId: string) =>
    `/scoring/p4-validations/${validationId}/reject`,
} as const;

export default p4ValidationEndpoints;
